import type { StagedComposerSubmission } from "../../composerStagedSubmission";
import type { ChatMessage } from "../../types";

export function stagedComposerSubmissionToChatMessage(
  submission: StagedComposerSubmission | null | undefined,
): ChatMessage | null {
  if (!submission?.messageId) {
    return null;
  }

  return {
    id: submission.messageId,
    role: "user",
    text: submission.prompt,
    createdAt: submission.startedAt,
    streaming: false,
    attachments: [
      ...submission.attachments.map((attachment) => ({
        type: "image" as const,
        id: attachment.id,
        name: attachment.name,
        mimeType: attachment.mimeType,
        sizeBytes: attachment.sizeBytes,
        previewUrl: attachment.dataUrl,
      })),
      ...submission.files.map((attachment) => ({
        type: "file" as const,
        id: attachment.id,
        name: attachment.name,
        mimeType: attachment.mimeType,
        sizeBytes: attachment.sizeBytes,
        downloadUrl: "",
      })),
    ],
  };
}
